import React from 'react';
import { Link } from 'react-router-dom';

const items = [
  ["/breeds" ,   'Породы'],
  ["/shows",     'Выставки'],
  ["/experts" ,  'Эксперты'],
  ["/dogs" ,     'Собаки'],
  ["/reports" ,  'Отчёты'],
  ["/contacts",  'Контакты'],
  ["/users",     'Пользователи'],
  ["/registration-requests", 'Заявки на выставку'],
];
export default function Dashboard() {
  return (
    <div className="row col-lg-10 col-md-8 col-sm-12 cards">
      {items.map(item => (
        <div key={item[0]} className="mb-2 col-sm-6 col-md-4 col-lg-2">
          <h5>
            <Link to={item[0]} className="card">{item[1]}</Link>
          </h5>
        </div>
      ))}
    </div>
  );
}